/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Last_Sound_Bison_DripInputs */

const fr_last_sound_bison_drip = /** @type {(inputs: Last_Sound_Bison_DripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorisé (rôle de base)`)
};

/**

* @param {Last_Sound_Bison_DripInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const last_sound_bison_drip = /** @type {((inputs?: Last_Sound_Bison_DripInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Last_Sound_Bison_DripInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_last_sound_bison_drip(inputs)
});